import React from 'react';
import { Oval } from 'react-loader-spinner';
import { motion } from 'framer-motion';

export const LoadingSpinner = () => (
  <motion.div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    initial={{
      height: 'calc(100vh - 87px)',
      width: '100%',
      opacity: 0,
    }}
    animate={{
      height: 'calc(100vh - 87px)',
      width: '100%',
      opacity: 1,
    }}
    exit={{ height: 'calc(100vh - 87px)', width: '100%', opacity: 0 }}
    transition={{ delay: 0.1 }}
  >
    <Oval color="grey" height={36} width={36} timeout={30000} />
  </motion.div>
);
